
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export const CTASection = () => {
  const navigate = useNavigate();

  const handleExternalLogin = () => {
    // This would be replaced with your actual external login URL
    const externalLoginUrl = "https://auth.myqoop.com";
    
    // For demo purposes, we're redirecting to the login page that will then simulate a redirect
    navigate('/login');
    
    // In a real application, we would redirect to the external URL:
    // window.location.href = externalLoginUrl;
    
    toast.info('Redirecting to login portal...');
  };

  return (
    <section className="py-20 bg-emergency-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4 text-emergency-700">15 Minutes Now Could Save Lives Later</h2>
          <p className="text-lg text-muted-foreground mb-8">Don't put off what could be the most important plan you ever make. It takes just minutes to create a plan that could make all the difference when seconds count.</p>
          <div className="flex justify-center">
            <Button 
              size="lg" 
              className="px-8 bg-emergency-600 hover:bg-emergency-700 text-white font-medium"
              onClick={handleExternalLogin}
            >
              Create Your Plan Now <ArrowRight size={18} className="ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
